import { t } from '../i18n'
import type { Explanation } from '../types'

/** Объяснение изменения уровня: кто против кого, чего ждали, что вышло,
 *  и вывод человеческим языком. Одинаково в превью, карточке матча и профиле —
 *  игрок должен видеть одну и ту же логику везде. */
export default function Why({
  why,
  mine = true,
  tournament,
}: {
  why: Explanation
  mine?: boolean
  /** Итог турнира: уровни пар — средние по всем матчам; в americano счёт идёт на очки */
  tournament?: 'americano' | 'pairs'
}) {
  const team = why.team_level.toFixed(2)
  const opp = why.opp_level.toFixed(2)
  const lines = [
    tournament ? t().whyPairAvg(team, opp) : mine ? t().whyPair(team, opp) : t().whyPairOf(team, opp),
    (tournament === 'americano' ? t().whyExpectedPoints : t().whyExpected)(
      Math.round(why.expected * 100),
      Math.round(why.actual * 100),
    ),
    t().reason[why.reason] ?? '',
  ]
  if (why.capped) lines.push(t().capped)
  // Про калибровку говорим, только когда уровень заметно сдвинулся —
  // иначе строка повторяется под каждым матчем и перестаёт читаться
  if (mine && why.calibrating && (why.reason === 'better' || why.reason === 'worse')) {
    lines.push(t().calibrating)
  }

  return (
    <div className="why">
      {lines.filter(Boolean).map((line, i) => (
        <div key={i}>{line}</div>
      ))}
    </div>
  )
}
